import {formattedPropertyModel, intlShape} from '@wallaby-ui/core';
import {isNil} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './PercentFormatter.less';

class PercentFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    const propDefinition = new formattedPropertyModel.FormattedProperty({
      type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_PERCENT,
    });
    const formattedValue = !isNil(value)
      ? formattedPropertyModel.FormattedProperty.formatValue(
          propDefinition,
          value,
          intl
        )
      : '';
    return !isNil(value) ? (
      <div className={styles.dlPercentFormatter} title={formattedValue}>
        {formattedValue}
      </div>
    ) : (
      ''
    );
  }
}

PercentFormatter.displayName = 'PercentFormatter';

PercentFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PercentFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(PercentFormatter);
